import React from "react";
import PropTypes from "prop-types";

/**
 * CardContent - Content area for card body
 * Provides consistent padding for card content
 * 
 * @component
 * @example
 * <CardContent>
 *   <h2>Card Title</h2>
 *   <p>Card description...</p>
 * </CardContent>
 */
const CardContent = ({
    children,
    className = "",
}) => {
    return (
        <div className={`px-3 ${className}`}>
            {children}
        </div>
    );
};

CardContent.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default CardContent;
